import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import PropTypes from 'prop-types';

const PageHeader = ({ title, routeSegments = [] }) => {
  return (
    <Box mb={4}>
      {/* Title */}
      <Typography variant="h4" fontWeight="bold">
        {title}
      </Typography>

      {/* Breadcrumbs */}
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb" sx={{ mb: 1 }}>
        {routeSegments.map((segment, index) => {
          const isLast = index === routeSegments.length - 1;
          return isLast ? (
            <Typography key={segment.name}>
              {segment.name}
            </Typography>
          ) : (
            <Link key={segment.name} underline="hover" href={segment.path}>
              {segment.name}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default PageHeader;